import type { AdvertisingAdvisory, AmazonSearchTerm } from "../../api/client";

export function AmazonInsights({
  searchTerms,
  advisory,
}: {
  searchTerms: AmazonSearchTerm[];
  advisory: AdvertisingAdvisory | null;
}) {
  return (
    <section className="amazon-insights" aria-labelledby="amazon-insights-title">
      <div className="finding-heading">
        <div>
          <h3 id="amazon-insights-title">搜索词与只读广告建议</h3>
          <p>所有数值来自确定性分析；建议仅供人工评估，不会写入广告账户。</p>
        </div>
        <span>{advisory?.candidates.length ?? 0} 条候选</span>
      </div>
      <div className="insight-columns">
        <div>
          <h4>搜索词指标</h4>
          <div className="insight-list">
            {searchTerms.slice(0, 20).map((item) => (
              <article key={`${item.sku}:${item.search_term}`}>
                <div>
                  <strong>{item.search_term}</strong>
                  <small>
                    {item.sku} · {item.clicks} 点击 · {item.attributed_orders} 订单
                  </small>
                </div>
                <span>
                  {item.currency} {item.spend}
                </span>
                {item.evidence_links[0] && <a href={item.evidence_links[0]}>查看证据</a>}
              </article>
            ))}
            {searchTerms.length === 0 && <p>当前报告没有可充分计算的搜索词指标。</p>}
          </div>
        </div>
        <div>
          <h4>广告建议候选</h4>
          <div className="insight-list">
            {advisory?.candidates.slice(0, 20).map((item) => (
              <article key={item.candidate.candidate_id}>
                <div>
                  <strong>{candidateLabel(item.candidate.candidate_type)}</strong>
                  <small>
                    {item.candidate.sku}
                    {item.candidate.search_term ? ` · ${item.candidate.search_term}` : ""}
                  </small>
                </div>
                <span>{item.candidate.reason_code}</span>
                {item.evidence_links[0] && <a href={item.evidence_links[0]}>查看证据</a>}
              </article>
            ))}
            {advisory && advisory.candidates.length === 0 && <p>没有指标达到已发布建议阈值。</p>}
          </div>
        </div>
      </div>
      {advisory && (
        <p className="advisory-boundary">
          策略版本 {String(advisory.policy_snapshot.version)} · advisory_only = true
        </p>
      )}
    </section>
  );
}

function candidateLabel(value: string): string {
  const labels: Record<string, string> = {
    negative_keyword: "负向关键词候选",
    expansion_keyword: "扩展关键词候选",
    budget: "预算建议候选",
    bid: "竞价建议候选",
  };
  return labels[value] ?? value;
}
